import List from '@mui/material/List';
import { styled } from '@mui/material/styles';
import clsx from 'clsx';
import { useDispatch } from 'react-redux';
import FuseNavItem from '../FuseNavItem';
import * as React from "react";
import { Divider, ListItemButton, ListItemText, ListSubheader, Stack, Typography } from '@mui/material';
import AgentJwtService from 'app/services/agent/AgentJwtService';
import { logoutUser } from 'app/agent/store/agentUserSlice';
import { Link, generatePath } from 'react-router-dom';
import { useEffect } from 'react';
import { getPagesList } from 'app/main/apps/pages/store/PageSlice.js';
import { useState } from 'react';
import { getSettings, forceLogoutUser, updateChecker } from 'app/main/apps/settings/store/settingsSlice';
import PowerSettingsNewIcon from '@mui/icons-material/PowerSettingsNew';
const StyledList = styled(List)(({ theme }) => ({
  //Keep this for future other designs
  // '& .fuse-list-item': {
  //   '&:hover': {
  //     backgroundColor:
  //       theme.palette.mode === 'dark' ? 'rgba(255, 255, 255, 0.05)' : 'rgba(0,0,0,.04)',
  //   },
  //   '&:focus:not(.active)': {
  //     backgroundColor:
  //       theme.palette.mode === 'dark' ? 'rgba(255, 255, 255, 0.06)' : 'rgba(0,0,0,.05)',
  //   },
  // },
  '&.dense': {
    '& .fuse-list-item': {
      paddingTop: 0,
      paddingBottom: 0,
      height: 32,
    },
  },
  '& .fuse-list-item': {
    height: 45,
    marginTop: 8,
    marginBottom: 8,
    minWidth: "47px"
  },
  '&.active-square-list': {
    '& .fuse-list-item, & .active.fuse-list-item': {
      width: '100%',
      borderRadius: '0',

    },
  },
  '& .MuiListItemText-root .MuiTypography-root': {
    fontSize: '14px',
    fontWeight: "bold",
  },
  '& .active.fuse-list-item': {
    backgroundColor: "#FFF7E8 !important",
    color: "#FBB633 !important",
  },
  '& .material-icons ': {
    marginRight: "18px !important",
    fontSize: '2.3rem',
    color: '#141f2c !important',
    opacity: '.5',
  },
  '& .fuse-list-item:hover ': {
    // color: 'unset',
    // '&.material-icons svg path': {
    //   // fill: '#FBB633 ',
    //   stroke: '#141F2C !important',
    // },
  },
  '& .active.fuse-list-item .material-icons': {
    fill: '#FBB633 ',
    opacity: 'unset',
  },
  '& .active.fuse-list-item .material-icons svg path': {
    // fill: '#FBB633 ',
    stroke: '#FBB633 ',

  },


}));

// icons
class EditProfileIcon extends React.Component {
  render() {
    return (
      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><g transform="translate(-32 -669)"><g transform="translate(32 669)"><g stroke="rgba(0,0,0,0)" strokeWidth="1" opacity="0"><rect width="24" height="24" stroke="none" /><rect x="0.5" y="0.5" width="23" height="23" fill="none" /></g><path d="M22,3H2A2.074,2.074,0,0,0,0,5V19a2.074,2.074,0,0,0,2,2H22a2.074,2.074,0,0,0,2-2V5a2.074,2.074,0,0,0-2-2m0,16H2V5H22V19m-8-2V15.75c0-1.66-3.34-2.5-5-2.5s-5,.84-5,2.5V17H14M9,7a2.5,2.5,0,1,0,2.5,2.5A2.5,2.5,0,0,0,9,7m5,0V8h6V7H14m0,2v1h6V9H14m0,2v1h4V11H14" /></g></g></svg>
    )
  }
}
class UpdateAccountIcon extends React.Component {
  render() {
    return (
      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><g transform="translate(-281 -450)"><g transform="translate(281 450)" stroke="rgba(0,0,0,0)" strokeWidth="1" opacity="0"><rect width="24" height="24" stroke="none" /><rect x="0.5" y="0.5" width="23" height="23" fill="none" /></g><path d="M10,4a4,4,0,1,0,4,4,4,4,0,0,0-4-4m0,2A2,2,0,1,1,8,8a2,2,0,0,1,2-2m7,6a.212.212,0,0,0-.24.24L16.5,13.5c-.22.18-.54.34-.78.5l-1.28-.5a.409.409,0,0,0-.32.1l-.96,1.76a.2.2,0,0,0,.08.32l1.04.82v1l-1.04.82c-.08.08-.16.24-.08.32l.96,1.76a.409.409,0,0,0,.32.1l1.28-.5c.24.16.56.32.78.5l.26,1.26A.212.212,0,0,0,17,22h2a.255.255,0,0,0,.24-.24l.16-1.26c.32-.18.64-.34.88-.5l1.22.5c.14,0,.3,0,.3-.1l1.04-1.76c.08-.08,0-.24-.08-.32l-1.04-.82v-1l1.04-.82c.08-.08.16-.24.08-.32L21.8,13.6c0-.1-.16-.1-.3-.1l-1.22.5c-.24-.16-.56-.32-.88-.5l-.16-1.26A.255.255,0,0,0,19,12H17m-7,1c-2.67,0-8,1.33-8,4v3h9.67a6.764,6.764,0,0,1-.58-1.9H3.9V17c0-.64,3.13-2.1,6.1-2.1a9.483,9.483,0,0,1,1.3.1,7.465,7.465,0,0,1,.82-1.79A13.512,13.512,0,0,0,10,13m8.04,2.5a1.487,1.487,0,0,1,1.46,1.54,1.468,1.468,0,0,1-1.46,1.46,1.487,1.487,0,0,1-1.54-1.46A1.5,1.5,0,0,1,18.04,15.5Z" transform="translate(280 449)" /></g></svg>
    )
  }
}
class FriendManegerIcon extends React.Component {
  render() {
    return (
      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 26 26"><g stroke="rgba(0,0,0,0)" strokeWidth="1" opacity="0"><rect width="24" height="24" stroke="none" /><rect x="0.5" y="0.5" width="23" height="23" fill="none" /></g><path d="M12,5a3.5,3.5,0,1,0,3.5,3.5A3.5,3.5,0,0,0,12,5m0,2a1.5,1.5,0,1,1-1.5,1.5A1.5,1.5,0,0,1,12,7M5.5,8a2.5,2.5,0,1,0,1.21,4.68,2.614,2.614,0,0,0,.91-.87A5.42,5.42,0,0,1,6.5,8.5V8.22A2.363,2.363,0,0,0,5.5,8m13,0a2.363,2.363,0,0,0-1,.22V8.5a5.42,5.42,0,0,1-1.12,3.31,2.756,2.756,0,0,0,.4.49,2.335,2.335,0,0,0,.51.38,2.448,2.448,0,0,0,2.42,0A2.5,2.5,0,0,0,18.5,8M12,14c-2.34,0-7,1.17-7,3.5V19H19V17.5c0-2.33-4.66-3.5-7-3.5m-7.29.55C2.78,14.78,0,15.76,0,17.5V19H3V17.07a3.168,3.168,0,0,1,1.71-2.52m14.58,0A3.168,3.168,0,0,1,21,17.07V19h3V17.5c0-1.74-2.78-2.72-4.71-2.95M12,16a10.374,10.374,0,0,1,4.23,1H7.77A10.374,10.374,0,0,1,12,16Z" /></svg>
    )
  }
}
class ProDashboardIcon extends React.Component {
  render() {
    return (
      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><g stroke="rgba(0,0,0,0)" strokeWidth="1" opacity="0"><rect width="24" height="24" stroke="none" /><rect x="0.5" y="0.5" width="23" height="23" fill="none" /></g><path d="M9,17H7V10H9v7m4,0H11V7h2V17m4,0H15V13h2v4m2,2H5V5H19V19.1M19,3H5A2.006,2.006,0,0,0,3,5V19a2.006,2.006,0,0,0,2,2H19a2.006,2.006,0,0,0,2-2V5A2.006,2.006,0,0,0,19,3Z" /></svg>
    )
  }
}
class FriendsActivityIcon extends React.Component {
  render() {
    return (
      <svg xmlns="http://www.w3.org/2000/svg" width="26" height="26" viewBox="0 0 27 27">
        <g id="friends-icon" transform="translate(-5093.979 -968)">
          <g id="Group_1544" data-name="Group 1544" transform="translate(-2.67 0.762)">
            <path id="Path_1103" data-name="Path 1103" d="M8.314,5.623a3.583,3.583,0,0,1,3.227,2.07,3.544,3.544,0,0,1-1.226,4.431c-.283.191-.574.369-.895.574.394.113.747.2,1.093.313a6.315,6.315,0,0,1,4.019,3.376,5.35,5.35,0,0,1,.478,2.032,1.063,1.063,0,0,1-.336.85,3.531,3.531,0,0,1-1.3.756,12.682,12.682,0,0,1-3.359.674q-.873.074-1.745.075a19.3,19.3,0,0,1-2.507-.162,9.418,9.418,0,0,1-3-.789c-1.307-.645-1.286-1.041-1.093-2.132a5.769,5.769,0,0,1,3.184-4.178,9.364,9.364,0,0,1,2.079-.742c.067-.018.134-.04.249-.076-.286-.179-.533-.325-.771-.485A3.423,3.423,0,0,1,4.778,8.6,3.39,3.39,0,0,1,7.335,5.766a3.438,3.438,0,0,1,.979-.142m0-1.577h0a5.049,5.049,0,0,0-1.431.207A4.953,4.953,0,0,0,3.216,8.348a4.91,4.91,0,0,0,.847,3.795A7.3,7.3,0,0,0,.1,17.418c-.293,1.663-.068,2.821,1.949,3.818a10.912,10.912,0,0,0,3.5.94,21.036,21.036,0,0,0,2.713.175c.618,0,1.25-.027,1.879-.08a14.139,14.139,0,0,0,3.775-.768,5.077,5.077,0,0,0,1.866-1.114,2.626,2.626,0,0,0,.8-2.049,6.854,6.854,0,0,0-.626-2.621,7.608,7.608,0,0,0-3.442-3.576,5.083,5.083,0,0,0,.452-5.113A5.175,5.175,0,0,0,8.314,4.046" transform="translate(5096.77 967.928)" stroke="#000" stroke-width="0.3" />
            <path id="Path_1104" data-name="Path 1104" d="M20.717,17.4c.214-.048.377-.092.441-.109.181-.049.319-.092.4-.117s.2-.063.356-.117c.105-.037.233-.083.4-.151.067-.028.159-.066.279-.123.062-.029.156-.073.275-.141.073-.041.151-.085.25-.153.032-.022.115-.079.215-.162.071-.059.122-.106.138-.122a1.825,1.825,0,0,0,.143-.144,1.324,1.324,0,0,0,.143-.2,1.268,1.268,0,0,0,.081-.165.946.946,0,0,0,.04-.132,1.226,1.226,0,0,0,.039-.252c0-.041,0-.079,0-.156s-.008-.146-.016-.236c-.005-.064-.016-.179-.035-.332-.014-.1-.037-.278-.084-.5-.031-.148-.059-.257-.067-.288-.025-.093-.064-.234-.121-.4-.064-.185-.122-.323-.144-.373-.043-.1-.079-.175-.11-.242-.042-.086-.095-.193-.159-.314-.077-.142-.141-.25-.166-.292-.077-.128-.141-.226-.173-.275-.1-.152-.182-.262-.206-.294l-.075-.1c-.035-.045-.1-.126-.182-.226-.029-.034-.1-.12-.2-.228-.117-.126-.211-.216-.231-.236s-.125-.12-.27-.243c-.02-.017-.091-.077-.188-.154-.144-.114-.259-.2-.307-.23s-.189-.132-.356-.237c-.068-.042-.176-.108-.311-.183-.027-.015-.1-.054-.192-.1-.047-.024-.156-.08-.3-.147-.1-.046-.294-.136-.552-.234-.16-.06-.276-.1-.46-.157-.1-.031-.233-.072-.5-.151-.173-.052-.318-.094-.494-.143L17.929,8.8c.211-.137.358-.234.454-.3l.178-.12.235-.158c.089-.062.187-.129.3-.223.041-.034.135-.111.248-.219a3.882,3.882,0,0,0,.358-.4c.028-.035.111-.143.207-.291.061-.1.1-.171.123-.2s.049-.087.094-.178c.07-.141.116-.254.137-.3l.086-.234.063-.206c.028-.1.045-.183.054-.229a4.083,4.083,0,0,0,.066-.408,4.421,4.421,0,0,0,.024-.445A4.306,4.306,0,0,0,20.3,3.473a3.992,3.992,0,0,0-.186-.422,4.1,4.1,0,0,0-.637-.913A3.83,3.83,0,0,0,18.135,1.2,3.635,3.635,0,0,0,17.27.965a3.59,3.59,0,0,0-.49-.04,3.678,3.678,0,0,0-.949.121c-.145.038-.252.075-.321.1-.222.078-.384.153-.418.169a3.952,3.952,0,0,0-.609.352,3.756,3.756,0,0,0-.322.256c-.113.1-.2.187-.229.222a3.457,3.457,0,0,0-.231.274" transform="translate(5094.89 968.062)" fill="none" stroke="#000" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" />
          </g>
          <rect id="Rectangle_432" data-name="Rectangle 432" width="24" height="24" transform="translate(5094 968)" fill="none" />
        </g>
      </svg>
    )
  }
}
class BlogsIcon extends React.Component {
  render() {
    return (
      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 26 26"><g transform="translate(-5234 -901)"><rect width="24" height="24" transform="translate(5234 901)" fill="none" /><g transform="translate(5237 903.5)"><path d="M146.428,4.053h-3.371c-1.77,0-2.655,0-3.331.344a3.165,3.165,0,0,0-1.381,1.381C138,6.455,138,7.34,138,9.11v7.8c0,1.77,0,2.655.344,3.331a3.165,3.165,0,0,0,1.381,1.381c.676.344,1.561.344,3.331.344h7.8c1.77,0,2.655,0,3.331-.344a3.165,3.165,0,0,0,1.381-1.381c.344-.676.344-1.561.344-3.331V13.535m-7.374,4.214h-6.321m8.428-4.214h-8.428m13.822-9.609a3.16,3.16,0,1,1-4.469,0A3.16,3.16,0,0,1,156.036,3.926Z" transform="translate(-138 -3)" fill="none" stroke="#000" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" /></g></g></svg>
    )
  }
}
class HomeIcon extends React.Component {
  render() {
    return (
      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 26 26"><g transform="translate(-5042 -900)"><rect width="24" height="24" transform="translate(5042 900)" fill="none" /><g transform="translate(5044 902)"><path d="M9.289,3H4.863a2.893,2.893,0,0,0-1.227.127,1.165,1.165,0,0,0-.509.509A2.893,2.893,0,0,0,3,4.863V9.289a2.893,2.893,0,0,0,.127,1.227,1.165,1.165,0,0,0,.509.509,2.893,2.893,0,0,0,1.227.127H9.289a2.893,2.893,0,0,0,1.227-.127,1.165,1.165,0,0,0,.509-.509,2.893,2.893,0,0,0,.127-1.227V4.863a2.893,2.893,0,0,0-.127-1.227,1.165,1.165,0,0,0-.509-.509A2.893,2.893,0,0,0,9.289,3Z" transform="translate(-3 -3)" fill="none" stroke="#000" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" /><path d="M20.289,3H15.863a2.893,2.893,0,0,0-1.227.127,1.165,1.165,0,0,0-.509.509A2.893,2.893,0,0,0,14,4.863V9.289a2.893,2.893,0,0,0,.127,1.227,1.165,1.165,0,0,0,.509.509,2.893,2.893,0,0,0,1.227.127h4.425a2.893,2.893,0,0,0,1.227-.127,1.165,1.165,0,0,0,.509-.509,2.893,2.893,0,0,0,.127-1.227V4.863a2.893,2.893,0,0,0-.127-1.227,1.165,1.165,0,0,0-.509-.509A2.893,2.893,0,0,0,20.289,3Z" transform="translate(-2.152 -3)" fill="none" stroke="#000" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" /><path d="M20.289,14H15.863a2.893,2.893,0,0,0-1.227.127,1.164,1.164,0,0,0-.509.509A2.893,2.893,0,0,0,14,15.863v4.425a2.893,2.893,0,0,0,.127,1.227,1.164,1.164,0,0,0,.509.509,2.893,2.893,0,0,0,1.227.127h4.425a2.893,2.893,0,0,0,1.227-.127,1.164,1.164,0,0,0,.509-.509,2.893,2.893,0,0,0,.127-1.227V15.863a2.893,2.893,0,0,0-.127-1.227,1.164,1.164,0,0,0-.509-.509A2.893,2.893,0,0,0,20.289,14Z" transform="translate(-2.152 -2.152)" fill="none" stroke="#000" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" /><path d="M9.289,14H4.863a2.893,2.893,0,0,0-1.227.127,1.165,1.165,0,0,0-.509.509A2.893,2.893,0,0,0,3,15.863v4.425a2.893,2.893,0,0,0,.127,1.227,1.165,1.165,0,0,0,.509.509,2.893,2.893,0,0,0,1.227.127H9.289a2.893,2.893,0,0,0,1.227-.127,1.165,1.165,0,0,0,.509-.509,2.893,2.893,0,0,0,.127-1.227V15.863a2.893,2.893,0,0,0-.127-1.227,1.165,1.165,0,0,0-.509-.509A2.893,2.893,0,0,0,9.289,14Z" transform="translate(-3 -2.152)" fill="none" stroke="#000" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" /></g></g></svg>
    )
  }
}

function FuseNavVerticalLayout1(props) {
  const { navigation, selectedId, layout, active, dense, className, onItemClick } = props;
  const dispatch = useDispatch();
  const [data, setData] = useState([]);
  const [copyright, setCopyright] = useState('');

  function handleItemClick(item) {
    onItemClick?.(item);
  }

  useEffect(() => {
    dispatch(getPagesList()).then((action) => {
      setData(action.payload);
    })
    dispatch(getSettings()).then((action) => {
      setCopyright(action.payload && action.payload.copyright ? action.payload.copyright : 'Copyright © 2023 Planet Impossible.');
    })
  }, [dispatch])

  const token = AgentJwtService.getDecodedAccessToken();

  useEffect(() => {

    const myFunction = () => {
      if (token.id) {
        dispatch(forceLogoutUser({ agentId: token.id, userType: 'agent' })).then((action) => {
          if (action.payload) {
            dispatch(logoutUser())
          }
        })
        dispatch(updateChecker({ agentId: token.id, userType: 'agent' })).then((action) => {
          if (action.payload) {
            AgentJwtService.setUserRefreshToken();
          }
        })
      }
    };

    const intervalId = setInterval(myFunction, 5000);

    return () => clearInterval(intervalId);
  }, []);

  const navigationConfig = [
    {
      id: "home",
      title: "Home",
      show: true,
      translate: "Home",
      type: "item",
      icon: < HomeIcon />,
      url: token.firstName ? "/public/home" : (!token.id ? "/" : "/agentprofile/new-user?isNew=true"),
    },
    {
      id: "friendsactivity",
      title: "Friends Activity",
      show: true,
      translate: "Friends Activity",
      type: "item",
      icon: < FriendsActivityIcon />,
      url: token.firstName ? "/public/friends-activity" : (!token.id ? "/agentlogin" : "/agentprofile/new-user?isNew=true"),
    },
    // {
    // //   id: "blog",
    // //   title: "Blog",
    // //   show: true,
    // //   translate: "Blog",
    // //   type: "item",
    // //   icon: < BlogsIcon />,
    // //   url: token.firstName || !token.id ? "/public/blog" : "/agentprofile/new-user?isNew=true",
    // // },


  ];

  // const navigationConfig2 = [
  //   {
  //     id: "dashboard",
  //     title: "Dashboard",
  //     show: false,
  //     translate: "Dashboard",
  //     type: "item",
  //     icon: < ProDashboardIcon />,
  //     url: token.firstName || !token.id ? "" : "/agentprofile/new-user?isNew=true",
  //   },
  //   {
  //     id: "friendmanager",
  //     title: "Friend Manager",
  //     show: true,
  //     translate: "Friend Manager",
  //     type: "item",
  //     icon: < FriendManegerIcon />,
  //     url: token.firstName || !token.id ? "/public/friends-manager" : "/agentprofile/new-user?isNew=true",
  //   },
  //   {
  //     id: "missionmanager",
  //     title: "Mission Manager",
  //     show: true,
  //     translate: "Mission Manager",
  //     type: "item",
  //     icon: < ProDashboardIcon />,
  //     url: token.firstName || !token.id ? "/public/mission-manager" : "/agentprofile/new-user?isNew=true",
  //   },


  // ];

  const navigationConfig3 = [

    // {
    //   id: "agentpage",
    //   title: "Agent Page",
    //   show: true,
    //   translate: "Agent Page",
    //   type: "collapse",
    //   icon: < EditProfileIcon />,
    //   // url: token.firstName || !token.id ? "/public/create-mission" : "/agentprofile/new-user?isNew=true",
    //   children: [
    //     {
    //       id: "createmission",
    //       title: "Create Mission",
    //       show: true,
    //       translate: "Create Mission",
    //       type: "item",
    //       // icon: < FriendManegerIcon />,
    //       url: token.firstName ? "/public/create-mission" : (!token.id ? "/agentlogin" : "/agentprofile/new-user?isNew=true"),
    //     },
    //     {
    //       id: "missionmanager",
    //       title: "Mission Manager",
    //       show: true,
    //       translate: "Mission Manager",
    //       type: "item",
    //       // icon: < FriendManegerIcon />,
    //       url: token.firstName ? "/public/mission-manager" : (!token.id ? "/agentlogin" : "/agentprofile/new-user?isNew=true"),
    //     },
    //     {
    //       id: "friendsmanager",
    //       title: "Friends Manager",
    //       show: true,
    //       translate: "Mission Manager",
    //       type: "item",
    //       // icon: < ProDashboardIcon />,
    //       url: token.firstName ? "/public/friends-manager" : (!token.id ? "/agentlogin" : "/agentprofile/new-user?isNew=true"),
    //     },
    //     {
    //       id: "community",
    //       title: "Community",
    //       show: true,
    //       translate: "Community",
    //       type: "item",
    //       // icon: < ProDashboardIcon />,
    //       url: token.firstName ? "/public/community" : (!token.id ? "/agentlogin" : "/agentprofile/new-user?isNew=true"),
    //     },
    //     {
    //       id: "editpage",
    //       title: "Edit Page",
    //       show: true,
    //       translate: "Edit Page",
    //       type: "item",
    //       // icon: < ProDashboardIcon />,
    //       url: token.firstName ? "/agentprofile/edit" : (!token.id ? "/agentlogin" : "/agentprofile/new-user?isNew=true"),
    //     },
    //   ]
    // }


  ];

  const navigationConfig4 = [
    // {
    //   id: "settingsaccount",
    //   title: "Settings Account",
    //   show: true,
    //   translate: "Settings Account",
    //   type: "item",
    //   icon: < ProDashboardIcon />,
    //   url: token.firstName || !token.id ? "/public/settings" : "/agentprofile/new-user?isNew=true",
    // },
    {
      id: "account",
      title: "Account",
      show: true,
      translate: "Account",
      type: "item",
      icon: < UpdateAccountIcon />,
      url: token.firstName ? "/agentprofile/account" : (!token.id ? "/agentlogin" : "/agentprofile/new-user?isNew=true"),
    },


  ];

  const navigationConfig5 = [
    {
      id: "termsofservice",
      title: "Terms of Service",
      show: true,
      translate: "Terms of Service",
      type: "item",
      icon: < ProDashboardIcon />,
      url: token.firstName ? "" : (!token.id ? "/agentlogin" : "/agentprofile/new-user?isNew=true"),
    },
    {
      id: "privacypolicy",
      title: "Privacy Policy",
      show: true,
      translate: "Privacy Policy",
      type: "item",
      icon: < FriendManegerIcon />,
      url: token.firstName ? "/public/privacy-policy" : (!token.id ? "/agentlogin" : "/agentprofile/new-user?isNew=true"),
    },


  ];

  return (
    <StyledList
      className={clsx(
        'navigation whitespace-nowrap px-12',
        `active-${active}-list`,
        dense && 'dense',
        className
      )}
    >
      <Divider className=" mb-8" />

      {navigationConfig.map((_item) => (
        _item.show ?
          <FuseNavItem
            key={_item.id}
            type={`vertical-${_item.type}`}
            item={_item}
            nestedLevel={0}
            onItemClick={handleItemClick}
          /> : null
      ))}
      <Divider className=" my-8" />
      {/* <ListSubheader disableSticky component="div" id="nested-list-subheader">
        ACCOUNT MENU
      </ListSubheader>
      {navigationConfig2.map((_item) => (
        _item.show ?
          <FuseNavItem
            key={_item.id}
            type={`vertical-${_item.type}`}
            item={_item}
            nestedLevel={0}
            onItemClick={handleItemClick}
          /> : null
      ))} */}


      {navigationConfig3.map((_item) => (
        _item.show ?
          <FuseNavItem
            key={_item.id}
            type={`vertical-${_item.type}`}
            item={_item}
            nestedLevel={0}
            onItemClick={handleItemClick}
          /> : null
      ))}
      {/* 
      <Divider className=" my-8" /> */}
      {navigationConfig4.map((_item) => (
        _item.show ?
          <FuseNavItem
            key={_item.id}
            type={`vertical-${_item.type}`}
            item={_item}
            nestedLevel={0}
            onItemClick={handleItemClick}
          /> : null
      ))}
      {token.id &&
        <ListItemButton
          className="my-10 rounded-md bg-pi-light-grey hover:bg-grey-400 min-w-[47px]"
          onClick={() => dispatch(logoutUser())}
          sx={{
            justifyContent: 'center', // Center icon
            padding: '10px', // Adjust padding
            minWidth: 40, // Ensure it's not too wide
          }}
        >
          <PowerSettingsNewIcon sx={{ color: "#314159", fontSize: 24 }} /> {/* Icon only */}
        </ListItemButton>
      }

    </StyledList >
  );
}

export default FuseNavVerticalLayout1;